import React from 'react';
import { GraduationCap, Building2, MessageSquareHeart } from 'lucide-react';

const INTEGRATIONS = [
  { icon: GraduationCap, title: 'Canvas', desc: 'Sincroniza matrículas, cursado y avance académico.' },
  { icon: Building2, title: 'HubSpot', desc: 'Trae el estado comercial y de cobranza de cada alumno.' },
  { icon: MessageSquareHeart, title: 'NPS', desc: 'Combina el pulso de satisfacción con el riesgo académico.' },
];

export const LandingIntegrations = () => (
  <section id="integraciones" className="max-w-7xl mx-auto px-6 py-20" data-testid="landing-integrations">
    <div className="text-center max-w-2xl mx-auto mb-14">
      <p className="text-sm font-semibold text-emerald-700 mb-3">Integraciones</p>
      <h2 className="font-manrope text-3xl sm:text-4xl font-bold text-gray-900">
        Se conecta con lo que ya usás
      </h2>
    </div>

    <div className="grid sm:grid-cols-3 gap-6">
      {INTEGRATIONS.map((int) => (
        <div key={int.title} className="flex flex-col items-center text-center border border-gray-100 rounded-2xl p-8" data-testid={`landing-integration-${int.title.toLowerCase()}`}>
          <int.icon className="w-8 h-8 text-gray-700 mb-4" />
          <h3 className="font-manrope font-bold text-gray-900 mb-2">{int.title}</h3>
          <p className="text-sm text-gray-600 leading-relaxed">{int.desc}</p>
        </div>
      ))}
    </div>
  </section>
);
